import { format, differenceInDays } from 'date-fns';

interface ArticleFreshnessProps {
  publishedAt: string;
  updatedAt: string;
  /** Minimum days difference to show "updated" line (default: 1) */
  minDaysForUpdate?: number;
}

/**
 * Shows article publish date and conditionally shows update date
 * if the article was meaningfully updated (not just auto-saved).
 */
export function ArticleFreshness({
  publishedAt,
  updatedAt,
  minDaysForUpdate = 1,
}: ArticleFreshnessProps) {
  const publishDate = new Date(publishedAt);
  const updateDate = new Date(updatedAt);
  
  // Only show "updated" if there's at least minDaysForUpdate difference
  const daysDifference = differenceInDays(updateDate, publishDate);
  const wasUpdated = daysDifference >= minDaysForUpdate;

  return (
    <p className="text-xs text-coal leading-relaxed italic">
      This article was originally published on{' '}
      <span className="not-italic font-medium">
        {format(publishDate, 'MMMM d, yyyy')}
      </span>
      {wasUpdated && (
        <>
          {' '}and was last updated on{' '}
          <span className="not-italic font-medium">
            {format(updateDate, 'MMMM d, yyyy')}
          </span>
        </>
      )}
      .
    </p>
  );
}
